import React from 'react';
import {
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import { ActivityFilters } from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityFilters';
import fr from 'facet-rest';
import { ActivityItems } from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityItems';
import PropTypes from 'prop-types';

const ActivityTabLayout = ({ collection, showFilters }) => {
  return (
    <FDPaper appearance={'flat'}>
      <FDStack direction={'column'}>
        {showFilters && <ActivityFilters collection={collection} />}
        <ActivityItems collection={collection} />
      </FDStack>
    </FDPaper>
  );
};

ActivityTabLayout.defaultProps = {
  showFilters: false,
};

ActivityTabLayout.propTypes = {
  collection: fr.Collection.isRequired,
  showFilters: PropTypes.bool,
};

export { ActivityTabLayout };
